/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileInvitationStatusResponse } from '../../models/profile-invitation-status-response';

export interface GetInvitationStatus$Params {

/**
 * Hash of invitation from invitation email.
 */
  hash: string;
}

export function getInvitationStatus(http: HttpClient, rootUrl: string, params: GetInvitationStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileInvitationStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getInvitationStatus.PATH, 'get');
  if (params) {
    rb.path('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileInvitationStatusResponse>;
    })
  );
}

getInvitationStatus.PATH = '/rest/invitation/{hash}';
